// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__18slV","notes":"Notes_notes__nYO-L"};